import {
  createTemplate,
  fetchTemplates,
  updateTemplate,
  deleteTemplate,
} from "@/api/templateService";

export default {
  //Create template
  async createTemplate({ commit, rootState, dispatch }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.templateBtn.load = true;
      rootState.loading.templateBtn.disabled = true;
      await createTemplate(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Template created!",
          color: "success",
        },
        { root: true }
      );
      dispatch("fetchTemplates", 1);
      rootState.loading.templateBtn.load = false;
      rootState.loading.templateBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.templateBtn.load = false;
      rootState.loading.templateBtn.disabled = false;
    }
  },

  //Fetch templates
  async fetchTemplates({ commit }, pageNumber) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });

      const response = await fetchTemplates(pageNumber);
      const templates = response.data.data;
      commit("SET_TEMPLATE_DATA", templates);
      commit("SET_TEMPLATE_RECORDS", response.data.data.totalRecords);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your templates arrived.",
          color: "success",
        },
        { root: true }
      );
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.message || "Something went wrong",
          color: "error",
        },
        { root: true }
      );
    }
  },

  //Update template
  async updateTemplate({ commit, rootState, dispatch, state }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.templateUpdateBtn.load = true;
      rootState.loading.templateUpdateBtn.disabled = true;
      await updateTemplate(payload);
      const pageNumber = state.templates.currentPage;
      dispatch("fetchTemplates", pageNumber);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Template updated!",
          color: "success",
        },
        { root: true }
      );
      rootState.loading.templateUpdateBtn.load = false;
      rootState.loading.templateUpdateBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.templateUpdateBtn.load = false;
      rootState.loading.templateUpdateBtn.disabled = false;
    }
  },

  //Delete template
  async deleteTemplate(context, payload) {
    context.commit("SHOW_PROGRESSBAR", true, { root: true });
    await deleteTemplate(payload);
    const pageNumber = context.state.templates.currentPage;
    context.dispatch("fetchTemplates", pageNumber);
    context.commit("HIDE_PROGRESSBAR", false, { root: true });
    context.commit(
      "SHOW_SNACKBAR",
      {
        text: "Template deleted!",
        color: "success",
      },
      { root: true }
    );
  },
};
